import { Environment } from '../common/types';

const uikitWithVersion = 'https://uikit.developers.rio.cloud/3.0.0';

export const loadTheme = (environment: Environment) => {
    const cssThemeProvider = environment === Environment.RIO ? 'rio' : 'vw';
    document.documentElement.dataset.brand = cssThemeProvider;
    const link =
        document.head.querySelector<HTMLLinkElement>('link[data-uikit-brand-css], link[href*="uikit-theme-"]') ??
        document.createElement('link');
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = `${uikitWithVersion}/uikit-theme-${cssThemeProvider}.css`;
    link.dataset.uikitBrandCss = cssThemeProvider;
    if (!link.isConnected) {
        document.head.appendChild(link);
    }
};
